export const getPaymentIntentIdFromLocation = (
  search: string = typeof window !== "undefined" ? window.location.search : "",
): string | null => {
  const paymentIntentClientSecret = new URLSearchParams(search).get(
    "payment_intent_client_secret",
  );

  if (!paymentIntentClientSecret?.trim()) {
    return null;
  }

  const trimmed = paymentIntentClientSecret.trim();
  if (trimmed.includes("_secret_")) {
    return trimmed.split("_secret_")[0];
  }

  return trimmed;
};
